import React, { useState } from 'react';
import { Link } from 'react-router-dom'; // 👈 Adicionado pra navegação interna

export default function Contato() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    empresa: '',
    mensagem: ''
  });

  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Enviando...');

    try {
      const response = await fetch('https://formspree.io/f/xjkekkdq', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setStatus('Mensagem enviada com sucesso!');
        setFormData({ nome: '', email: '', telefone: '', empresa: '', mensagem: '' });
      } else {
        setStatus('Ocorreu um erro. Tente novamente.');
      }
    } catch (error) {
      setStatus('Ocorreu um erro. Tente novamente.');
    }
  };

  return (
    <section className="section contato" id="contato">
      <div className="contato-container">
        <div className="contato-info">
          <h2>Contato</h2>
          <p><strong>Email:</strong> contato@amaratech.com.br</p>
          <p><strong>Telefone:</strong> (21) 3197-0837</p>
          
          <p><strong>Canal de Denúncia:</strong></p>
          <Link to="/canal-de-denuncias" target="_blank" className="denuncia-contato-btn">
            Acessar Canal de Denúncias
          </Link>

          <p><strong>Endereço:</strong><br />
            R. da Assembléia, 10, Sala 1722<br />
            Centro – Rio de Janeiro RJ, 20011-901
          </p>

          <div className="mapa-container">
            <iframe
              title="Mapa Localização"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3673.9666930676617!2d-43.17847442472421!3d-22.956772840037577!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x997fd5c8c0bbfb%3A0xd68999dfadcff0d4!2sR.%20da%20Assembl%C3%A9ia%2C%2010%20-%20Centro%2C%20Rio%20de%20Janeiro%20-%20RJ%2C%2020011-901!5e0!3m2!1spt-BR!2sbr!4v1695571412431!5m2!1spt-BR!2sbr"
              width="100%"
              height="200"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>

        <div className="contato-form">
          <h2>Fale com a gente</h2>
          <form onSubmit={handleSubmit}>
            <input type="text" name="nome" placeholder="Nome" value={formData.nome} onChange={handleChange} required />
            <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
            <input type="tel" name="telefone" placeholder="Telefone" value={formData.telefone} onChange={handleChange} required />
            <input type="text" name="empresa" placeholder="Empresa" value={formData.empresa} onChange={handleChange} />
            <textarea name="mensagem" placeholder="Mensagem" rows="5" value={formData.mensagem} onChange={handleChange} required></textarea>
            <button type="submit">Enviar</button>
          </form>
          {status && <p style={{ marginTop: '10px', color: '#49e9fe' }}>{status}</p>}
        </div>
      </div>

      <footer className="footer">
        <p>
          Amaratech Soluções em Informática LTDA – 47.165.306/0001-61 © 2025 | Todos os Direitos Reservados.
        </p>
      </footer>
    </section>
  );
}
